/** Fechas escritas como dd/mm/aaaa (así se ven y se escriben en toda Donna); por dentro se guardan como aaaa-mm-dd. */

/** «2026-10-25» → «25/10/2026» («» si no es una fecha aaaa-mm-dd). */
export const fechaEnTexto = (iso: string): string => (/^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");

/** «25/10/2026» → «2026-10-25» si es una fecha real (rechaza 31/02/2026 o años menores a 1000); si no, null. */
export function fechaDeTexto(t: string): string | null {
  const m = t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const d = Number(m[1]), mes = Number(m[2]), a = Number(m[3]);
  const f = new Date(Date.UTC(a, mes - 1, d));
  return a >= 1000 && f.getUTCFullYear() === a && f.getUTCMonth() === mes - 1 && f.getUTCDate() === d ? `${m[3]}-${m[2]}-${m[1]}` : null;
}

/** Pone las barras mientras se escribe: «25102026» → «25/10/2026» (solo deja números, hasta 8). */
export function formatearFechaEscrita(t: string): string {
  const d = t.replace(/\D/g, "").slice(0, 8);
  return d.length <= 2 ? d : d.length <= 4 ? `${d.slice(0, 2)}/${d.slice(2)}` : `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}
